/**
 * This is the container for buy/success that grabs necessary data from the store
 * to render the more generic success
 */
import PropTypes from 'prop-types'

import React from 'react'
import DocumentTitle from 'react-document-title'
import { connect } from 'transfer/utils/p2p-connect'
import SuccessBase from './success-base'
import { Link } from 'react-router-dom'
import classnames from 'classnames'
import * as ViewActions from '../actions/Actions'
import SendPPMeClaimIframe from './send-ppme-claim-iframe'
import RTRSuccessBreakdown from './rtrSuccessBreakdown'
import { getGoToLink, getGoToLinkContentKey } from '../utils/success-utils'
import content from 'pp-react-l10n'
import * as pispUtils from '../utils/pisp-utils'
import enRTRStrings from '../../../../config/enRTRStrings'
import griffinPlural from 'griffin-paypal/plural'
import {
  hasMgmSuccessScreenEntryPointTreatment,
  hasMgmSuccessScreenEntryPointThreeTreatment,
} from 'experiments/mgm'
import { tracking } from '../../lib/analytics/mParticle'
import Events from '../../lib/analytics/eventTags'
import { isDw2Repaint } from '../../experiments/dw2Repaint'
import { Button, Link as PPLink } from '@paypalcorp/pp-react'
import glamorous from 'glamorous'

let i18n = content('transfer/send/success')

const DoneLinksDiv = glamorous.div({
  textAlign: 'center',
  margin: '2rem 0 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})
class BuySuccess extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    amountFormatted: PropTypes.string.isRequired,
    recipient: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    userState: PropTypes.string.isRequired,
    ppmeClaimUrl: PropTypes.string.isRequired,
    showPPMeIframe: PropTypes.bool.isRequired,
    complianceInfo: PropTypes.shape({
      status: PropTypes.string,
    }),
    selectedFundingOption: PropTypes.shape({
      isRTR: PropTypes.bool.isRequired,
    }),
    isNativeApp: PropTypes.bool.isRequired,
    isAndroid: PropTypes.bool.isRequired,
    isiPhone: PropTypes.bool.isRequired,
    isBusinessUser: PropTypes.bool.isRequired,
    sendMoreStartsOver: PropTypes.bool,
    rootURL: PropTypes.string,
    mtgplace: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    unified: PropTypes.bool.isRequired,
    transactionId: PropTypes.string,
    isPsd: PropTypes.bool.isRequired,
    isPpcp: PropTypes.bool.isRequired,
    iatUnilateralInfo: PropTypes.shape({
      hasIatUnilateralDisclosure: PropTypes.bool,
      iatDelayedDebitDuration: PropTypes.string,
    }),
    language: PropTypes.string,
    griffinMetadata: PropTypes.object.isRequired,
  }

  state = {
    hasSubmitFeedback: false,
  }

  componentWillMount() {
    const { unified } = this.props
    this.unified = unified
    // trigger the external hook for the success page
    this.props.dispatch(
      ViewActions.triggerExternalHook('successPageAfterRender', this.props)
    )

    if (this.props.sendMoreStartsOver) {
      this.sendMoreURL = this.props.rootURL
    } else if (unified) {
      let startURL = '/homepage/send'
      this.sendMoreURL = `${this.props.rootURL}${startURL}`
    } else {
      this.sendMoreURL = `${this.props.rootURL}/buy`
    }

    this.inviteMoreUrl = `${this.props.rootURL}/homepage/external/mgm?traffic_source=send_money_success`
    this.isMgmEntryPoint =
      hasMgmSuccessScreenEntryPointTreatment() ||
      hasMgmSuccessScreenEntryPointThreeTreatment()
  }

  // ppcp, need to redirect user back to third party site after 2 secs
  handleRedirect() {
    if (this.props.isPpcp) {
      const transactionId = this.props.transactionId
      pispUtils.handlePpcpSuccessRedirect(transactionId, 'goods_and_services')
    }
  }

  componentDidMount() {
    this.handleRedirect()
  }

  handleAndroidClick = event => {
    event.preventDefault()
    window.open('paypalbusiness://openpaypalbusiness?status=1')
  }

  renderAndroidDoneLinksComponent = () => {
    return isDw2Repaint() ? (
      <DoneLinksDiv>
        <Button type="button" onClick={this.handleAndroidClick}>
          {i18n('success.doneButton')}
        </Button>
        <Button
          tertiary={true}
          as={Link}
          to={this.sendMoreURL}
          data-pagename="main:p2p:buy::done"
          data-pagename2="main:p2p:buy::done:node::"
          data-nextpagegroup="main:p2p:buy::start"
          data-nextpagename="main:p2p:buy:start:node::"
        >
          {i18n('success.sendMoreMoney')}
        </Button>
      </DoneLinksDiv>
    ) : (
      <div className="doneLinks">
        <button
          type="button"
          onClick={this.handleAndroidClick}
          className="vx_btn done"
        >
          {i18n('success.doneButton')}
        </button>

        <Link
          to={this.sendMoreURL}
          data-pagename="main:p2p:buy::done"
          data-pagename2="main:p2p:buy::done:node::"
          data-nextpagegroup="main:p2p:buy::start"
          data-nextpagename="main:p2p:buy:start:node::"
        >
          {i18n('success.sendMoreMoney')}
        </Link>
      </div>
    )
  }

  renderiPhoneDoneLinksComponent = () => {
    return isDw2Repaint() ? (
      <DoneLinksDiv>
        <Button
          as="a"
          href="https://paypal-business-app/send-money/goBackToNative"
        >
          {i18n('success.doneButton')}
        </Button>
        <Button
          tertiary={true}
          as={Link}
          to={this.sendMoreURL}
          data-pagename="main:p2p:buy::done'"
          data-pagename2="main:p2p:buy::done:node::"
          data-nextpagegroup="main:p2p:buy::start"
          data-nextpagename="main:p2p:buy:start:node::"
        >
          {i18n('success.sendMoreMoney')}
        </Button>
      </DoneLinksDiv>
    ) : (
      <div className="doneLinks">
        <a
          href="https://paypal-business-app/send-money/goBackToNative"
          className="vx_btn done"
        >
          {i18n('success.doneButton')}
        </a>

        <Link
          to={this.sendMoreURL}
          data-pagename="main:p2p:buy::done'"
          data-pagename2="main:p2p:buy::done:node::"
          data-nextpagegroup="main:p2p:buy::start"
          data-nextpagename="main:p2p:buy:start:node::"
        >
          {i18n('success.sendMoreMoney')}
        </Link>
      </div>
    )
  }

  renderMerchantAppDoneLinksComponent = () => {
    if (this.props.isAndroid) {
      return this.renderAndroidDoneLinksComponent()
    } else if (this.props.isiPhone) {
      return this.renderiPhoneDoneLinksComponent()
    }
  }

  renderDoneLinksComponent = () => {
    const isMgmEntryPointThree = hasMgmSuccessScreenEntryPointThreeTreatment()

    if (this.props.isNativeApp) {
      return this.renderMerchantAppDoneLinksComponent()
    }

    /* Do not show any CTAs for hawk ppcp as we redirect to their flow and do not want users to click on any CTA*/
    if (this.props.isPpcp) {
      return null
    }

    const sendMoreClasses = classnames({
      vx_btn: true,
      done: true,
    })

    const inviteFriendClasses = classnames({
      vx_btn: isMgmEntryPointThree,
      'vx_btn-secondary': isMgmEntryPointThree,
      done: isMgmEntryPointThree,
    })

    const unifiedString = this.unified ? 'unified:' : ''

    return isDw2Repaint() ? (
      <DoneLinksDiv>
        <Button
          as={Link}
          to={this.sendMoreURL}
          data-pagename={`main:p2p:${unifiedString}buy::done`}
          data-pagename2={`main:p2p:${unifiedString}buy::done:node::`}
          data-nextpagegroup="main:p2p:buy::start"
          data-nextpagename="main:p2p:buy:start:node::"
          data-nemo="buy-send-more-money"
        >
          {i18n('success.sendMoreMoney')}
        </Button>
        {!this.isMgmEntryPoint && !this.props.isBusinessUser && (
          <div style={{ margin: '1rem 0' }}>
            <PPLink href={getGoToLink()}>
              {i18n(getGoToLinkContentKey())}
            </PPLink>
          </div>
        )}
        {this.isMgmEntryPoint && (
          <>
            <Button
              tertiary={true}
              as={Link}
              to={this.inviteMoreUrl}
              data-pagename="main:p2p:buy::done"
              onClick={() =>
                tracking(Events.p2p_success_invite_friend_pressed())
              }
            >
              {i18n('success.mgmInviteFriend')}
            </Button>
          </>
        )}
      </DoneLinksDiv>
    ) : (
      <div className="doneLinks">
        <Link
          to={this.sendMoreURL}
          className={sendMoreClasses}
          data-pagename={`main:p2p:${unifiedString}buy::done`}
          data-pagename2={`main:p2p:${unifiedString}buy::done:node::`}
          data-nextpagegroup="main:p2p:buy::start"
          data-nextpagename="main:p2p:buy:start:node::"
          data-nemo="buy-send-more-money"
        >
          {i18n('success.sendMoreMoney')}
        </Link>

        {!this.isMgmEntryPoint && !this.props.isBusinessUser && (
          <div className="action">
            <a href={getGoToLink()}>{i18n(getGoToLinkContentKey())}</a>
          </div>
        )}

        {this.isMgmEntryPoint && (
          <div className="action">
            <Link
              className={inviteFriendClasses}
              to={this.inviteMoreUrl}
              data-pagename="main:p2p:buy::done"
              onClick={() =>
                tracking(Events.p2p_success_invite_friend_pressed())
              }
            >
              {i18n('success.mgmInviteFriend')}
            </Link>
          </div>
        )}
      </div>
    )
  }

  render() {
    const {
      selectedFundingOption: { isRTR = false },
      complianceInfo: { status = '' } = {},
      iatUnilateralInfo: {
        hasIatUnilateralDisclosure = false,
        iatDelayedDebitDuration = '',
      } = {},
      language = '',
    } = this.props
    const isOFAC = status === 'PENDING'
    const showENSubTextRTR = isRTR === true && language !== 'en'

    const recipient = this.props.displayName || this.props.recipient

    const successHeaderContent = i18n('success.successHeader', {
      recipient,
      amountFormatted: this.props.amountFormatted,
    })

    const successHeaderTranslatedContent = `${enRTRStrings.successHeader[0]} ${recipient} ${enRTRStrings.successHeader[1]} ${this.props.amountFormatted}`

    const successIatUnilateralHeader = i18n(
      'success.successIatUnilateralHeader',
      {
        recipient,
        amountFormatted: this.props.amountFormatted,
      }
    )

    const griffinHandler = griffinPlural.createHandler(
      this.props.griffinMetadata
    )
    const plurals = griffinHandler.getPlural(Number(iatDelayedDebitDuration), {
      type: griffinHandler.PLURAL_CARDINAL,
    })

    const successIatUnilateralSubheader = i18n.html(
      `success.successIatUnilateralSubheader_${plurals}`,
      {
        iatDelayedDebitDuration,
      }
    )

    const rtrSuccessBreakdownComponent = (
      <RTRSuccessBreakdown
        selectedFundingOption={this.props.selectedFundingOption}
        complianceInfo={this.props.complianceInfo}
        isGoods={true}
        recipient={this.props.recipient}
        showENSubTextRTR={showENSubTextRTR}
      />
    )
    const unifiedString = this.unified ? 'unified:' : ''

    return (
      <DocumentTitle title={i18n('a11y.title.send.success')}>
        <SuccessBase
          intent="buy"
          amountFormatted={this.props.amountFormatted}
          recipient={this.props.recipient}
          displayName={this.props.displayName}
          userState={this.props.userState}
          ppmeClaimUrl={this.props.ppmeClaimUrl}
          showPPMeIframe={this.props.showPPMeIframe}
          selectedFundingOption={this.props.selectedFundingOption}
          complianceInfo={this.props.complianceInfo}
          isNativeApp={this.props.isNativeApp}
          iconClassName="icon-register"
          isOFAC={isOFAC}
          isRTR={isRTR}
          ppmeClaimIframeComponent={<SendPPMeClaimIframe />}
          rtrSuccessBreakdownComponent={rtrSuccessBreakdownComponent}
          successHeaderTranslatedContent={successHeaderTranslatedContent}
          successHeaderContent={successHeaderContent}
          doneLinksComponent={this.renderDoneLinksComponent()}
          transactionId={this.props.transactionId}
          pageName={`main:p2p:${unifiedString}buy::done`}
          pageName2={`main:p2p:${unifiedString}buy::done:node::`}
          showAppBanner={true}
          hasIatUnilateralDisclosure={hasIatUnilateralDisclosure}
          iatDelayedDebitDuration={iatDelayedDebitDuration}
          successIatUnilateralHeader={successIatUnilateralHeader}
          successIatUnilateralSubheader={successIatUnilateralSubheader}
          showENSubTextRTR={showENSubTextRTR}
        />
      </DocumentTitle>
    )
  }
}

export default connect(
  ({ address, amount, recipient, transaction, server, unilateral, user }) => ({
    amountFormatted: amount.amountFormatted,
    recipient: recipient.recipient,
    displayName: unilateral.name || recipient.displayName,
    userState:
      address.addresses &&
      address.addresses[0] &&
      address.addresses[0].state &&
      address.addresses[0].state.value,
    ppmeClaimUrl: transaction.ppmeClaimUrl,
    showPPMeIframe: transaction.showPPMeIframe,
    selectedFundingOption: transaction.selectedFundingOption,
    complianceInfo: transaction.complianceInfo,
    iatUnilateralInfo: transaction.paymentDetails.iatUnilateralInfo,
    isNativeApp: server.isNativeApp,
    isAndroid: server.isAndroid,
    isiPhone: server.isiPhone,
    sendMoreStartsOver: server.env === 'xb',
    rootURL: server.rootURL,
    isBusinessUser: server.businessAccountInfo.isBusinessUser,
    mtgplace: transaction.mtgplace,
    category: transaction.category,
    transactionId: transaction.paymentDetails.payment_id,
    isPsd: server.env === 'pisp',
    isPpcp: server.env === 'hawk-ppcp',
    language: user.language,
    griffinMetadata: server.griffinMetadata,
  })
)(BuySuccess)
